import NewEventForm from '../../components/newEventForm/NewEventForm';
import * as Yup from 'yup';
import {newEventInitialValues,newEventSteps, newEventValidationSchema} from '../../globalSteps';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';

function NewLecturesEvent() {
    const event=useSelector(s=>s.event);
    const {t} = useTranslation(['global', 'newEvent', 'errors', 'layout']);
   
    const lecturesSteps = [
        {
            ...newEventSteps.title,
            navigationLabel: 'titleLecture',
            texts: {topHeader: 'titleTopHeaderLecture', topAfterFill: 'titleTopAfterFillLecture'},
            compProps: {text: 'eventTitleLecture'}
        },
        {
            ...newEventSteps.location,
            texts: {header: 'locationHeaderLecture', description: 'locationDescriptionLecture'}
        },
        {
            ...newEventSteps.date,
            texts: {header: 'dateHeaderLecture', topHeader: 'dateTopHeaderLecture', description: 'dateDescriptionLecture'}
        },
        {
            ...newEventSteps.artists,
            navigationLabel: 'artistsLecture',
            texts: {header: 'artistsHeaderLecture', description: 'artistsDescriptionLecture'},
            compProps: {findArtistsKey: 'findArtistsLecture'}
        },
        {
            ...newEventSteps.description,
            texts: {header: 'descriptionHeaderLecture', description: 'descriptionDescriptionLecture'}
        },
    ];
    const {title,locale, location, date, artists, description}=newEventInitialValues(event);
    
    const initialValues = {
        title,
        locale,
        location,
        date,
        artists,
        description
    };
    const {title: titleValid, description: descriptionValid, date: dateValid, locale: localValid, location: locationValid}=newEventValidationSchema(t);

    const lectureDateValid = dateValid.shape({
        startDate: dateValid.fields.startDate.required(t('errors:requiredError', {name: t('newEvent:startDate')})),
        startTime: dateValid.fields.startTime.required(t('errors:requiredError', {name: t('newEvent:startTime')})),
    }).required();

    const initialValidationSchema = Yup.object().shape({
        title: titleValid,
        description: descriptionValid,
        locale: localValid,
        location: locationValid,
        date: lectureDateValid
    });
    return (
        <NewEventForm
            initialValues={initialValues}
            validationSchema={initialValidationSchema}
            steps={lecturesSteps}
        />
    );
}

export default NewLecturesEvent;
